module.exports = new __parcel__URL__("../images/excepte-jeunes.95f70cf8.png").toString();